<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2019-12-16
 * @LastEditors: WUFAN
 * @LastEditTime: 2019-12-18
 -->
<template>
  <div class="div_email_captcha">

    <el-form class="login-form"
           status-icon
           :rules="loginRules"
           ref="loginForm"
           :model="loginForm"
           label-width="0"
           style="width:100%">
           <p>请选择密码找回方式</p>
    <el-select v-model="value" style="margin-bottom:10px;width:100%" placeholder="请选择密码找回方式">
      <el-option
        v-for="item in passwordVerifyList"
        :key="item.description"
        :value="item.description"
        :disabled="item.disabled">
      </el-option>
    </el-select>
      <el-form-item prop="username" >
        <p>请输入账号</p>
        <el-input size="small"
                  @keyup.enter.native="didTapToNext"
                  v-model="loginForm.username"
                  autocomplete="off"
                  placeholder="请输入账号"
                  style="margin-bottom:10px;">
          <i slot="prefix"   class="icon-yonghu"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                  size="small"
                  @click.native.prevent="didTapToNext"
                  :loading="submitLoading"
                  class="login-submit"
                  style="width:100%;">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      passwordVerifyList: [],
      loginForm: {
        username: ''
      },
      value: '',
      type: null,
      selectType: {},
      'submitLoading': false,
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ]
      }
    }
  },

  watch: {
    value() {
      let array = this.passwordVerifyList
      let that = this
      array.forEach(function(item, index, arr) {
        if (that.value === item.description) {
          that.type = item.type
          that.selectType = item
        }
      })
    }
  },

  mounted: function() {
    this.fetchGetPasswordWay()
  },
  methods: {
    fetchGetPasswordWay: function() {
      this.$http.get('/self/retrieve-password/type', { params: {
      }}).then(response => {
        this.passwordVerifyList = response.data
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },

    didTapToNext: function() {
      /** 跳转发送验证码 */
      if (this.type === null) {
        this.$message.error('请选择密码找回方式')
      } else {
        var childrenInfo = {}
        childrenInfo.status = 1 // 注入下一步状态
        childrenInfo.type = this.type // 注入验证方式
        childrenInfo.account = this.loginForm.username // 注入账户值
        childrenInfo.selectType = this.selectType
        this.$emit('fatherMethod', childrenInfo)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
  .div_email_captcha{
    display:flex;
    flex-direction:column;
    align-items: center
  }
  .div_email_captcha el-button{
    height: 100px;
    width: 100px;

  }
</style>
